import axios from "axios";
import { fileApiUrl } from "../config/apiConfig";

const apiUploads = axios.create({
  baseURL: fileApiUrl,
});

// Intercepta todas as requisições para incluir o token atualizado
apiUploads.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Intercepta respostas para capturar erro 401 (Token expirado)
export const setupUploadsInterceptors = (logout) => {
  apiUploads.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        console.warn("⚠️ Erro 401 (uploads): Token expirado. Deslogando usuário...");
        logout();
      }
      return Promise.reject(error);
    }
  );
};

export default apiUploads;
